/*! @azure/msal-browser-1p v3.23.0 2024-09-03 */
'use strict';
import { BrowserStorage, BrowserCacheLocation, MemoryStorage } from '@azure/msal-browser';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const CACHED_REQUEST_PREFIX = "msal.request";
/**
 * Returns {TemporaryBrokerStorage}
 * @param {Configuration} config
 */
function getTemporaryBrokerStorage(config) {
    try {
        return new BrowserStorage(config.cache?.temporaryCacheLocation ||
            BrowserCacheLocation.SessionStorage);
    }
    catch (e) {
        return new MemoryStorage();
    }
}
/**
 * Returns the request key
 * @param clientId
 */
function getRequestKey(clientId) {
    return `${CACHED_REQUEST_PREFIX}.${clientId}`;
}

export { CACHED_REQUEST_PREFIX, getRequestKey, getTemporaryBrokerStorage };
//# sourceMappingURL=TemporaryBrokerStorage.mjs.map
